import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
    loadAutomatchGroupedWinningRuleset,
    loadAutomatchGroupedWinningRulesetFailure,
    loadAutomatchGroupedWinningRulesetSuccess
} from '../actions/automatch.actions';
import { WinningRuleSetClient } from 'src/app/compliance/api/winning-rule-set-client.service';
import { showToasterMessage } from 'src/app/shared/actions/toaster.actions';

@Injectable({
    providedIn: 'root'
})
export class AutomatchEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _winningRuleSetClient: WinningRuleSetClient
    ) {}

    loadAutomatchGroupedWinningRuleset$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(loadAutomatchGroupedWinningRuleset),
            switchMap((action) => {
                return this._winningRuleSetClient
                    .getGroupedWinningRuleset(action.getRuleExpressionsInHierarchyRequestDto)
                    .pipe(
                        map((groupedWinningRuleset) =>
                            loadAutomatchGroupedWinningRulesetSuccess({ groupedWinningRuleset })
                        ),
                        catchError((error) => of(loadAutomatchGroupedWinningRulesetFailure({ error })))
                    );
            })
        );
    });

    loadAutomatchGroupedWinningRulesetFailure$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(loadAutomatchGroupedWinningRulesetFailure),
            map(() => showToasterMessage({ message: 'Failed to load grouped winning ruleset.' }))
        );
    });
}
